import {Component} from '@angular/core';

@Component({
  selector: 'app-heatmap-legend',
  templateUrl: './heatmap-legend.component.html',
  styleUrls: ['./heatmap-legend.component.scss']
})
export class HeatmapLegendComponent {
}
